var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroundboy01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f1e5;}.cls-2{fill:#2ca0ff;}.cls-3{fill:#ffbe9f;}.cls-4{fill:#ff715d;}.cls-5{fill:#ebc2ff;}.cls-6{clip-path:url(#clip-path);}.cls-17,.cls-7{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}.cls-7{stroke-width:3px;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#f4e211;}.cls-10{clip-path:url(#clip-path-3);}.cls-11{clip-path:url(#clip-path-4);}.cls-12{clip-path:url(#clip-path-5);}.cls-13{fill:#e1b7f9;}.cls-14{clip-path:url(#clip-path-6);}.cls-15{clip-path:url(#clip-path-7);}.cls-16{fill:#e1dacf;}.cls-17{stroke-width:2px;}.cls-18{clip-path:url(#clip-path-8);}.cls-19{clip-path:url(#clip-path-9);}.cls-20{clip-path:url(#clip-path-10);}.cls-21{fill:#fff;}.cls-22{clip-path:url(#clip-path-11);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1090.12,760.68l82.93,54s64.88-13,92-74.27l-60.81-79.8L1090.12,760.68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1143.55,795.44s45.24,135.19,158.36,52.21l99.55-92.4a41.76,41.76,0,0,0,12.81-22.74c2.22-11.75-.17-26.86-21.35-36.65a65.3,65.3,0,0,0-54,0l-54.58,24.37s-57.84-32.14-51.76,43.79C1232.6,764,1197.32,808.46,1143.55,795.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1130.52,560.46l59.71,46.62s14.55-1.7,30.17-16.12c27.53-25.42,49-62.74,12.16-98.77a15.11,15.11,0,0,1-1.82-2.84,305.29,305.29,0,0,0-33.29-42.57l-66.93,113.68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1260.89,446.84l50.19-56.47a44.5,44.5,0,0,1,34.53-15.22c11.91.4,24.54,5.84,29.67,25a55.12,55.12,0,0,1,1,23.29c-3.9,23.37-18.68,91.66-67.09,170.79a58.65,58.65,0,0,1-5.78,7.59c-26,29.67-70.33,34.78-102.84,12.4l-20.81-14.32s43.11-20.16,67.32-77.23c-18.06-6-29.35-23.74-27.14-41.77C1222.31,461.28,1240.11,446.05,1260.89,446.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.32,570.87s16.69-62.06-39.67-168a48.9,48.9,0,0,1,18.69-65.28l.68-.39a77.89,77.89,0,0,1,33.62-9.84,48.35,48.35,0,0,1,37.9,15c18.92,19.83,40.07,47.86,58.15,83.95,30.19,60.23,49.55,144.2,6.25,239.2-27.63,23.78-68.39,24.69-96.63,2.49C520.23,645.09,512,603.63,530.32,570.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.57,233.07,479,196.85a7.13,7.13,0,0,1,8.92,2.8l75.25,122a5.45,5.45,0,0,1-2.59,7.92l-79.38,32.12a6.42,6.42,0,0,1-7.74-2.37L393.53,240A4.72,4.72,0,0,1,395.57,233.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.7,243.36l61.37,90.47a6,6,0,0,0,7.34,2.17l65-27.56a6,6,0,0,0,2.76-8.74l-57.38-92a6,6,0,0,0-7.46-2.36l-69,29.13A6,6,0,0,0,405.7,243.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M652.38,650.24c-10.58,26.24-24.19,78.09-21.82,136.55a314.48,314.48,0,0,0,21.81,102.84,297.26,297.26,0,0,1-67.1,1.34c-40.64-4-95.48-17.35-152.24-54.72L202.5,789.81S108.37,763,123.29,671.75c0,0,14.07-89.54,147.82-95.41l111.07,43.34s23.95-45.53,65-70.71c40.79-25,94.47-11.36,118.89,29.79,8.91,15,18.07,34.6,25.34,59.48C591.44,638.24,633.4,603.3,652.38,650.24Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 350.1,
    cy: 592.61,
    rx: 59.06,
    ry: 57.19,
    transform: "translate(-196.64 174.48) rotate(-22.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.28,562c-4.68,4.37-11.91,6.84-13.59,13-1.41,5.16,1.94,10.43,5.89,14s8.73,6.42,11.67,10.88c4.59,7,3.39,16.79-1.61,23.5s-13.12,10.55-21.37,11.93a35.62,35.62,0,0,1-19.59-1.82c-7.65-3.22-13.59-9.71-17.42-17.06-9.6-18.47-5.55-43.06,9.47-57.47-4.79-6.28-9.64-12.66-12.66-20s-4-15.79-1-23.1,10.7-12.94,18.55-12c5.78.71,10.73,4.74,13.94,9.6s5,10.51,6.67,16.08c3.37-9.68,7-19.82,14.74-26.58s20.79-8.55,27.74-1c10.44,11.33.18,25-8.63,33C326.44,542.7,330.45,554.3,322.28,562Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.82,
    cy: 638.92,
    r: 12.74
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ground boy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sock_2",
    "data-name": "sock 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1090.12,760.68l82.93,54s64.88-13,92-74.27l-60.81-79.8L1090.12,760.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1142.77,
    y1: 765.45,
    x2: 1172.28,
    y2: 788.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1185.41,
    y1: 725.94,
    x2: 1212,
    y2: 761.93
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shoe"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1143.55,795.44s45.24,135.19,158.36,52.21l99.55-92.4a41.76,41.76,0,0,0,12.81-22.74c2.22-11.75-.17-26.86-21.35-36.65a65.3,65.3,0,0,0-54,0l-54.58,24.37s-57.84-32.14-51.76,43.79C1232.6,764,1197.32,808.46,1143.55,795.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1250.22,856.45s69.37-40.93,149.93-122.43c0,0-10.11-14.77,3.39-24.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1163.17,844.26s51.6-37.79,88,29.7C1251.21,874,1191.85,901.17,1163.17,844.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1280.91,712.55s45.27,53.23,88.6-26.78C1369.51,685.77,1333.88,682.07,1280.91,712.55Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "sock"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1130.52,560.46l59.71,46.62s14.55-1.7,30.17-16.12c27.53-25.42,49-62.74,12.16-98.77a15.11,15.11,0,0,1-1.82-2.84,305.29,305.29,0,0,0-33.29-42.57l-66.93,113.68"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1180.04,
    y1: 549.37,
    x2: 1203.25,
    y2: 569.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1204.13,
    y1: 508.62,
    x2: 1229.04,
    y2: 542.08
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_2",
    "data-name": "shoe 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1260.89,446.84l50.19-56.47a44.5,44.5,0,0,1,34.53-15.22c11.91.4,24.54,5.84,29.67,25a55.12,55.12,0,0,1,1,23.29c-3.9,23.37-18.68,91.66-67.09,170.79a58.65,58.65,0,0,1-5.78,7.59c-26,29.67-70.33,34.78-102.84,12.4l-20.81-14.32s43.11-20.16,67.32-77.23c-18.06-6-29.35-23.74-27.14-41.77C1222.31,461.28,1240.11,446.05,1260.89,446.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1279,603.51s55.24-52.76,83.19-194.66c0,0-33.1-12.49-16.54-33.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1200.25,619.77s41.91-55.54,86.45,2.88C1286.7,622.65,1243.06,647,1200.25,619.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1255.81,435.81l12.39,7.4c20.86,12.46,47.91.57,52.55-23.28,2.75-14.15,2.2-31.57-6-51.75l-59,67.63"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "leg_2",
    "data-name": "leg 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M902.75,604.38l202.69,169.09S1155.71,762.86,1219,666.2L1073.55,478.09c-29.91-44-82.87-65-131-52.83-.89.23-1.78.46-2.67.71C860.33,448.19,839.32,551.46,902.75,604.38Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "leg_1",
    "data-name": "leg 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M652.37,889.63s-117.53-295.35,78.9-471.12c52.33-46.83,122.16-53.6,161.94-16.94,28,25.83,37.48,69.61,25.83,111.39-6.64,9.16-13.85,19.81-19.23,32.72-9.46,22.7-18.6,58.09-17.35,108.81,0,0,17.2,175.15-80.89,235.08-74.84,45.72-139.42,4.5-149.2.06"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "lower_leg_1",
    "data-name": "lower leg 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M715.32,436.87s133.17-180.72,370.46-80.09c0,0,64.76,23.52,121.33,101.19,0,0,12.55,65.14-68.44,108.85,0,0-177-168.06-247-3.12-37.61,44.68-104.05,52-149.63,17.59C698,548,685.92,485.06,715.32,436.87Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.32,570.87s16.69-62.06-39.67-168a48.9,48.9,0,0,1,18.69-65.28l.68-.39a77.89,77.89,0,0,1,33.62-9.84,48.35,48.35,0,0,1,37.9,15c18.92,19.83,40.07,47.86,58.15,83.95,30.19,60.23,49.55,144.2,6.25,239.2-27.63,23.78-68.39,24.69-96.63,2.49C520.23,645.09,512,603.63,530.32,570.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M497.21,372.8s31.36.67,68.32-29.12"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M395.38,239.52a4.15,4.15,0,0,1-2-4.89c.22-.7.45-1.41.71-2.13a58.49,58.49,0,0,1,3.32-7.59,10,10,0,0,1,4.24-3.56L481,185.72a10.14,10.14,0,0,1,12.74,3.86L569,309.64a10.14,10.14,0,0,1,.87,9,25.14,25.14,0,0,1-3.89,6.18,25.55,25.55,0,0,1-5.35,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.57,233.07,479,196.85a7.13,7.13,0,0,1,8.92,2.8l75.25,122a5.45,5.45,0,0,1-2.59,7.92l-79.38,32.12a6.42,6.42,0,0,1-7.74-2.37L393.53,240A4.72,4.72,0,0,1,395.57,233.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.7,243.36l61.37,90.47a6,6,0,0,0,7.34,2.17l65-27.56a6,6,0,0,0,2.76-8.74l-57.38-92a6,6,0,0,0-7.46-2.36l-69,29.13A6,6,0,0,0,405.7,243.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M481.2,235.9l-50.15,20.28c-2.9,1.17-6.07.46-7.54-1.68h0c-1.91-2.78-.22-6.73,3.53-8.24L477.19,226c2.78-1.13,5.83-.52,7.38,1.46h0C486.72,230.19,485.07,234.33,481.2,235.9Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 521.63,
    cy: 330.03,
    r: 5.73
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "fingers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.89,365.59s-43.49-1.31-50.59-55.23c0,0-2.63-32.28,3.57-50.22,0,0,24.46-8.54,27.26,44.41,0,0,18.86-6.05,37.51,11.4,15.5,14.51,10,40.19-10.06,47.25C491.13,364.07,488.56,364.87,485.89,365.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 518.79,
    cy: 237.45,
    r: 19.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 534.44,
    cy: 266.79,
    r: 18.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 546.58,
    cy: 291.15,
    r: 16.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M515.41,256.75s10,2.06,20.15-8.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M531.79,284.81s11.36,0,18.63-9.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M466.13,304.55s21.95-6.35,42.6,16.9"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M652.38,650.24c-10.58,26.24-24.19,78.09-21.82,136.55a314.48,314.48,0,0,0,21.81,102.84,297.26,297.26,0,0,1-67.1,1.34c-40.64-4-95.48-17.35-152.24-54.72L202.5,789.81S108.37,763,123.29,671.75c0,0,14.07-89.54,147.82-95.41l111.07,43.34s23.95-45.53,65-70.71c40.79-25,94.47-11.36,118.89,29.79,8.91,15,18.07,34.6,25.34,59.48C591.44,638.24,633.4,603.3,652.38,650.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M181.24,650.07s58.22-30.7,107.57,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M350.34,782.62s15.11-33.14.89-88.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "356.4 639.08 397.65 678.13 400.33 621.31 356.4 639.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "387.38 629.38 442.97 590.53 399.54 581.01 387.38 629.38"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 350.1,
    cy: 592.61,
    rx: 59.06,
    ry: 57.19,
    transform: "translate(-196.64 174.48) rotate(-22.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.1,565.76s14.48-3.56,15.65,5.86"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.28,562c-4.68,4.37-11.91,6.84-13.59,13-1.41,5.16,1.94,10.43,5.89,14s8.73,6.42,11.67,10.88c4.59,7,3.39,16.79-1.61,23.5s-13.12,10.55-21.37,11.93a35.62,35.62,0,0,1-19.59-1.82c-7.65-3.22-13.59-9.71-17.42-17.06-9.6-18.47-5.55-43.06,9.47-57.47-4.79-6.28-9.64-12.66-12.66-20s-4-15.79-1-23.1,10.7-12.94,18.55-12c5.78.71,10.73,4.74,13.94,9.6s5,10.51,6.67,16.08c3.37-9.68,7-19.82,14.74-26.58s20.79-8.55,27.74-1c10.44,11.33.18,25-8.63,33C326.44,542.7,330.45,554.3,322.28,562Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M272.47,580.71a32.6,32.6,0,0,0-2.1,20.08,5.38,5.38,0,0,0,1.19,2.71,2.09,2.09,0,0,0,2.7.35,3,3,0,0,0,.82-1.74l2.84-12.24,4.63,9.4c.37.74.82,1.56,1.61,1.79a2.05,2.05,0,0,0,2.16-1,5.92,5.92,0,0,0,.72-2.43c.49-3.33.88-7.07-1.15-9.77-1.22-1.64-3.18-2.63-4.29-4.35-1.26-1.94-1.2-4.48-.65-6.73s1.52-4.39,2-6.66-.18-5.25-2.43-5.58c-1.81-.27-3.26,1.43-4.19,3a39.67,39.67,0,0,0-5.29,23.3"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_1",
    "data-name": "eyebrow 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.2,
    cy: 584.04,
    rx: 5.3,
    ry: 8.63,
    transform: "translate(-23.49 14.46) rotate(-2.33)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_2",
    "data-name": "eyebrow 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.82,
    cy: 548.98,
    rx: 8.25,
    ry: 5.01,
    transform: "translate(-288.03 416.79) rotate(-45.84)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "ear"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.82,
    cy: 638.92,
    r: 12.74
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M311.31,641.15a7,7,0,0,1,.79-6.53,6.58,6.58,0,0,1,6.29-2.54"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "eye1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.72,
    cy: 582.71,
    rx: 3.71,
    ry: 2.5,
    transform: "translate(-78.66 56.62) rotate(-8.12)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "eye2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.54,
    cy: 552.2,
    rx: 3.64,
    ry: 2.15,
    transform: "translate(-74.32 56.85) rotate(-8.12)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M369.79,583.7s9.42,2.7,14.19-8.54"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 359.28,
    cy: 597.3,
    r: 5.27
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M882.69,629.75s1.17-166.48,135.84-134"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M532.28,580.62s61.31-42.42,132.59,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1063.4,513.62s27.3,10.17,75.27,53.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M695,755.64s88.11-5.48,73.51,98.65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundboy01);
export default __webpack_public_path__ + "static/media/ground boy-01.118ce5dbb9b969be901eb58d1c299500.svg";
export { ForwardRef as ReactComponent };